var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg099Withdraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 20H20V3C20 2.44772 19.5523 2 19 2H5C4.44772 2 4 2.44772 4 3V20H3C2.44772 20 2 20.4477 2 21C2 21.5523 2.44772 22 3 22H21C21.5523 22 22 21.5523 22 21C22 20.4477 21.5523 20 21 20ZM18 4V20H6V4H18ZM9 16C9 15.4477 9.44772 15 10 15H12C12.5523 15 13 14.5523 13 14C13 13.4477 12.5523 13 12 13C10.548 12.9887 9.31249 11.9392 9.0666 10.5081C8.82071 9.07703 9.63503 7.67528 11 7.18V7C11 6.44772 11.4477 6 12 6C12.5523 6 13 6.44772 13 7H14C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9H12C11.4477 9 11 9.44772 11 10C11 10.5523 11.4477 11 12 11C13.452 11.0113 14.6875 12.0608 14.9334 13.4919C15.1793 14.923 14.365 16.3247 13 16.82V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17H10C9.44772 17 9 16.5523 9 16Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg099Withdraw);
export default __webpack_public_path__ + "static/media/099-withdraw.15449b05846559831f348c7c76bf85b1.svg";
export { ForwardRef as ReactComponent };